import type { IconProps } from "../types";

export const BarChart4 = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <path d="M13 17V9" />
    <path d="M18 17V5" />
    <path d="M3 3v18h18" />
    <path d="M8 17v-3" />
  </svg>
);
